import axios from "axios";

const api = axios.create({
  baseURL: "/api",
  headers: { "Content-Type": "application/json" },
});

let authToken: string | null = null;

export function setToken(token: string | null) {
  authToken = token;
}

export function getToken(): string | null {
  return authToken;
}

api.interceptors.request.use((config) => {
  if (authToken) {
    config.headers.Authorization = `Bearer ${authToken}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // A wrong PIN or password on a sign-in call is an answer, not an expired
    // session. Bouncing to /login there signed the whole register out when a
    // cashier mistyped a PIN on SWITCH (Donovan 10/30).
    const isSignIn = String(error.config?.url || "").startsWith("/auth/");
    if (error.response?.status === 401 && !isSignIn) {
      authToken = null;
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default api;
